// extracted by mini-css-extract-plugin
module.exports = {"mt_02":"vestigingen_mt_02__3fsNg","modal_footer":"vestigingen_modal_footer__bwoZE"};